import { render } from "./HelpComponent.vue?vue&type=template&id=775a9d70"
const script = {}

import "./HelpComponent.vue?vue&type=style&index=0&id=775a9d70&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__